<template>
    <contentCardMobile :loading="loading" :elevation="0" classCard="px-0 mx-0 py-0" cardColor="transparent">
        <template slot="cardContent">
            <div >
                <v-row justify="space-around">
                    <v-col cols="12" md="5" >
                        <div class="font-weight-bold body-1 text-center">
                           Cursos Grupo Merca
                        </div>
                    </v-col>
                </v-row>
                 <v-row justify="space-around">
                    <v-col cols="12" md="5" class="py-0 mb-2">
                        <AlternativeAutocompleteOne
                            :label="'Empresa'"
                            :items="companies"
                            :valueInput="selectedCompany"
                            :loading="loadingCompanies"
                            @valueChange="(v) => {selectedCompany = v; resetPaginator(); index()}"
                        ></AlternativeAutocompleteOne>
                    </v-col>
                 </v-row>
            
                    

                <v-row justify="space-around">
                    <v-col cols="12" md="5" class="py-0">

                        <div class="text-center" v-if="loading">
                            <v-progress-circular
                                indeterminate
                                color="primary"
                            ></v-progress-circular>
                        </div>

                        

                        <div v-if="!loading && courses.length == 0" class="text-center">
                            <span>Sin resultados</span>
                        </div>

                        <div class="text-center" v-if="!loading && courses.length > 0">
                            <v-pagination
                                v-model="page"
                                :length="totalPages"
                                :total-visible="totalVisiblePages"
                                @input="() => {index()}"
                            ></v-pagination>
                        </div>

                        <div class="text-center" cols="12" md="6" v-for="(course, index) in courses" :key="index">
                            <div @click="openCourse(course.id)" class="my-2">
                                <CourseItem class="clic"  :course="course" :showChipStatus="true">
                                </CourseItem>
                            </div>
                            
                        </div>
                        <div class="text-center" v-if="!loading && courses.length > 0">
                            <v-pagination
                                v-model="page"
                                :length="totalPages"
                                :total-visible="totalVisiblePages"
                                @input="() => {index()}"
                            ></v-pagination>
                        </div>
                       
                        
                    </v-col>
                </v-row>
            </div>
        </template>
    </contentCardMobile>
    
</template>

<script>
// import Utils from '../../../helpers/Utils';
import PageStateManager from '../../../helpers/PageStateManager';
import CourseItem from '../../managerViews/courses/read/CourseItem.vue';
export default {
    
    components: {
        CourseItem
    },
	data(){
		return {
            loading: true,
            loadingCompanies: true,
            selectedCompany: PageStateManager.getState(this.$router.history.current.path, 'selectedCompany')??'ALL',
            page: PageStateManager.getState(this.$router.history.current.path, 'page')??'1',
            totalPages:1,
            totalVisiblePages:7,
            courses: [],
            companies: [],
		}
    },
    watch: {
       
        [`selectedCompany`]: function () {
            PageStateManager.setState(this.$router.history.current.path, 'selectedCompany', this.selectedCompany)
        },
        [`page`]: function () {
            console.log(this.page)
            PageStateManager.setState(this.$router.history.current.path, 'page', this.page)
        },
		
    },

    mounted(){
       this.getBusiness();
    },
	methods: {
        getBusiness()
        {
            this.companies = [];
            this.loadingCompanies = true;
            this.$api.user.getUserBusinessSelect()
				.then((resp) =>{
                    
                    //index filter
					// this.companies = resp.data.map((comp) => {
					// 	return {value: comp.id, text: `${comp.name}`}
					// });
                    this.companies.push({value: "ALL", text: "Todas"});
                    resp.data.forEach(comp => {
                        this.companies.push({value: comp.id, text: `${comp.name}`});
                    });

                    

					if(this.companies.length >= 1){
						if(this.selectedCompany == "")
                            this.selectedCompany = this.companies[0].value;
						this.index();
                        
					}

                    
					
				})
				.catch((error) =>{
					console.log(error, "error getBusinessSelect");
				})
				.finally(() => {
                    this.loadingCompanies = false;
				})
			;
        },
        resetPaginator(){
            this.page = 1;
            this.totalPages = 1;
            this.totalVisiblePages = 7;
        },

        index(){
            this.courses = [];
            this.loading = true;
            const filter = this.generateFilter();
            this.$api.employeeCourses.index(filter)
				.then((resp) =>{
                    console.log(resp)
                     this.courses = resp.data.data.map((x) => {
                        // x['status'] = 'completed';
                        return x;
                    });
                    this.page = resp.data.current_page;
                    this.totalPages = resp.data.last_page;

					
				})
				.catch((error) =>{
					console.log(error);
				})
				.finally(() => {
					// this.tableProps.loading = false;
                    this.loading = false;
				})
			;

          
        },

        openCourse(id){
            // console.log(id)
            this.$router.push({ name: 'EmployeeCoursesDetail', params: { id: id }}).catch(()=>{});
            
        },

        generateFilter()
        {
            let filter = `?page=${this.page}&itemsPerPage=10`;
            if(this.selectedCompany != 'ALL'){
                filter = `${filter}&filter[companies]=${this.selectedCompany}`
            }
            return filter;
        }
        
    },
}
</script>

<style lang="scss"> 
   
    
</style>